export default __webpack_public_path__ + "static/media/paypal.794b19f8.png";